export type ProductAvailabilityFilter =
  | 'all'
  | 'in-stock'
  | 'out-of-stock'
  | 'no-issues';

export type ProductBarcodeFilter = 'all' | 'has-barcode' | 'missing-barcode';

export interface ProductManagerFilters {
  selectedShop: { label: string; value: number | string } | null;
  productType: string;
  availability: ProductAvailabilityFilter;
  barcodeStatus: ProductBarcodeFilter;
  missingLinkedCigars: boolean;
  missingImages: boolean;
  missingPrice: boolean;
  lowPrice: boolean;
  quantityMismatch: boolean;
}

export const DEFAULT_PRODUCT_MANAGER_FILTERS: ProductManagerFilters = {
  selectedShop: null,
  productType: 'all',
  availability: 'all',
  barcodeStatus: 'all',
  missingLinkedCigars: false,
  missingImages: false,
  missingPrice: false,
  lowPrice: false,
  quantityMismatch: false,
};

export const buildProductManagerFilterParams = (
  filters: ProductManagerFilters
) => ({
  in_stock_only: filters.availability === 'in-stock',
  out_of_stock_only: filters.availability === 'out-of-stock',
  no_issues_only: filters.availability === 'no-issues',
  shop_id:
    filters.selectedShop && Number(filters.selectedShop.value) >= 0
      ? filters.selectedShop.value
      : null,
  product_type: filters.productType !== 'all' ? filters.productType : null,
  has_barcode: filters.barcodeStatus === 'has-barcode',
  missing_barcode: filters.barcodeStatus === 'missing-barcode',
  missing_linked_cigars: filters.missingLinkedCigars,
  missing_images: filters.missingImages,
  missing_price: filters.missingPrice,
  low_price: filters.lowPrice,
  quantity_mismatch: filters.quantityMismatch,
});

export const countProductManagerFilters = (filters: ProductManagerFilters) =>
  [
    filters.selectedShop && Number(filters.selectedShop.value) >= 0,
    filters.productType !== 'all',
    filters.availability !== 'all',
    filters.barcodeStatus !== 'all',
    filters.missingLinkedCigars,
    filters.missingImages,
    filters.missingPrice,
    filters.lowPrice,
    filters.quantityMismatch,
  ].filter(Boolean).length;
